<template>
  <div  class="OrderIndex">
      <div class="order-detail">
        <div class="order-detail-title">订单详情</div>
        <div class="order-detail-content">订单号：{{orderDetail.oid}}</div>
        <!--标注信息旗-->
        <OrderFlagMarker :orderDetail="orderDetail"  @getorderDetail="getorderDetail()"></OrderFlagMarker>
        <!--标注信息旗-->
        <el-button v-if="orderDetail.deal_time>0"   @click="printkle=true" size="small" icon="el-icon-printer"  style="margin-left: auto ;">打印订单</el-button>
        <!--询价状态-->
        <div class="order-detail-end" v-if="storeInfo.type==2&&$GFUN.isInArray([4],orderDetail.status)">
          <span class="red mr-2">{{clockCount }}</span>
          <el-button @click="showConfirmPanel=true" type="primary" size="small"  style="margin: 0 auto; display: block;">结束询价</el-button>
        </div>
        <!--管理员·审核按钮-->
        <div class="order-detail-end" v-if="storeInfo.type==99&&$GFUN.isInArray([1,2,3],orderDetail.status)">
          <el-button v-if="orderDetail.status==1" @click="verifyOrder(2)" type="primary" size="small"  style="margin: 0 auto; display: block;">审核通过</el-button>
          <el-button v-if="orderDetail.status==2" @click="verifyOrder(3)" type="primary" size="small"  style="margin: 0 auto; display: block;">匹配酒店</el-button>
          <el-button v-if="orderDetail.status==3" @click="verifyOrder(4)" type="primary" size="small"  style="margin: 0 auto; display: block;">推送酒店</el-button>
        </div>
      </div>
      <!--订单状态-->
      <OrderState :orderDetail="orderDetail"></OrderState>
      <!--订单团队信息-->
        <OrderTeam  :orderDetail="orderDetail"  @uploadInvoice="uploadInvoice" :flag="flag"></OrderTeam>
      <!---------------------------------订单询价状态--------------------------------->
      <div class="housing" v-if="orderDetail.deal_time==0&&orderDetail.ask_type!=1">
          <!--用房信息-->
          <OrderHousing :orderDetail="orderDetail" :quotationList="quotationList" @getorderDetail="getorderDetail()"></OrderHousing>
          <!--采购商·酒店报价列表-->
          <OrderQuotation  ref="orderQuotation" :orderDetail="orderDetail" :quotationList="quotationList" v-if="$GFUN.isInArray([2,99],storeInfo.type)" @getorderDetail="getorderDetail()" @updateflag="updateflag()"></OrderQuotation>
        <!--销售·酒店报价列表-->
        <OrderHotelQuotation 
         v-if="storeInfo.type==3"
         :orderDetail="orderDetail" 
         :quotationList="quotationList" 
         :match_hotel_list="match_hotel_list" 
         :match_store_id="match_store_id" 
          @quotationShow="(res) => onquotationShow(res)"
          @refuseShow="(res) => onrefuseShow(res)"
          @getorderDetail="getorderDetail()"
        >
        </OrderHotelQuotation>
      </div>
      <!---------------------------------订单已成交状态--------------------------------->
      <div v-else class="check mt-4">
        <!--酒店信息-->
        <OrderTeam :orderDetail="orderDetail" :type="3" @getorderDetail="getorderDetail()" @uploadInvoice="uploadInvoice" :flag="flag"  ></OrderTeam>
        <!--用房信息-->
        <OrderHousing :orderDetail="orderDetail" :quotationList="quotationList"></OrderHousing>
      </div>
      <!--核房人、支付人、入住名单-->
      <!-- <OrderCheckList :orderDetail="orderDetail"></OrderCheckList> -->
      <!--成交订单状态按钮-->
      <Orderbutton 
        :orderDetail="orderDetail" 
        v-if="$GFUN.isInArray([5,6,7,8,9],orderDetail.status)&&!flag" 
        @showConfirmPanel="showConfirmPanel=true" 
        @collectionShow="collectionShow=true"
        @getorderDetail="getorderDetail()"
        @viewChanges="onViewChanges"
        @receiptShow="dialogFormVisible=true"
        @recordShow="record=true"
        @paymentShow="paymentOpen=true"
        @modifyDepositShow="modifyDepositShow=true"
        @showCancelPanel="showCancelPanel=true"
        @getQRcode="getQRcode()"
        @uploadInvoice="uploadInvoice"
        ></Orderbutton>
       <!---------------------------------功能弹窗--------------------------------->
      <!--酒店报价弹窗-->
      <OrderHotelFill  
        ref="OrderHotelFill" 
        :orderDetail="orderDetail" 
        :quotationShow="quotationShow" 
        :match_hotel_list="match_hotel_list"  
        @onShow="quotationShow=false"
        @updateflag="updateflag"
        @getorderDetail="getorderDetail()"
      ></OrderHotelFill>
      <!--酒店接不了弹窗-->
      <OrderHoteRefuse ref="OrderHoteRefuse" :refuseShow="refuseShow"  :match_hotel_list="match_hotel_list" @onShow="refuseShow=false" @getorderDetail="getorderDetail();refuseShow=false"> </OrderHoteRefuse>
      <!--订单取消弹窗-->
      <verify-number url="/pc/User/GetSafeCode"  :number="orderDetail.send_mobile" v-if="showShopCar" @submitOrder="submitOrder" @switch="showShopCar=!showShopCar"> </verify-number>
      <el-dialog  :visible.sync="showConfirmPanel" width="340px" center id="loadConfirm" top="32vh" :close-on-click-modal="false" :show-close="false">
        <div class="mb-2" v-if="orderDetail.status==5">是否取消确认单？</div>
        <div class="mb-2" v-else>{{ orderDetail.deal_time>0?' 是否取消订单？':'是否结束询价？' }}</div>
          <el-autocomplete
            class="selects"
            v-model="arrow_down"
            :fetch-suggestions="querySearch"
            placeholder="请输入取消原因"
            @select="handleSelect"
          ></el-autocomplete>
          <div class="cancelPrompt" v-if="arrow_down==''&&cancelPrompt">请选择取消原因</div>
          <div slot="footer" class="cancel">
              <el-button size="small" @click="showConfirmPanel = false;arrow_down=''">返回</el-button>
              <el-button size="small" type="primary" @click="number">确认</el-button>
          </div>
      </el-dialog>
      <!--查看取消状态弹窗-->
      <el-dialog  :visible.sync="showCancelPanel"  width="340px" center id="loadConfirm" top="32vh">
         <div class="cancel-title">取消原因</div>
          <div class="cancel-prompt " >{{ orderDetail.cancel_remark||'无取消原因' }}</div>
          <div slot="footer" class="cancel">
              <template v-if="orderDetail.cancel_launch_uid==userLoginMessage.uid">
                <el-button size="small" type="primary" @click="cancelCancel">撤销取消</el-button>
              </template>
              <template v-else-if="!isAdmin">
                <el-button size="small"  @click="confirmCancel(0)">不同意</el-button>
                <el-button size="small" type="primary" @click="confirmCancel(1)">同意</el-button>
              </template>
          </div>
      </el-dialog>
      <!--代订收款弹窗-->
      <OrderCollectionOnDehalf :collectionShow="collectionShow" :orderDetail="orderDetail" :quotationList="quotationList" ref="collectionOnDehalf"  @onShow="collectionShow=false" />
      <!--查看修改弹窗-->
      <OrderConfirmPanel  ref="confirmPanel" :confirmPanelShow="confirmPanelShow" :orderDetail="orderDetail"  @onShow="confirmPanelShow=false" @getorderDetail="getorderDetail();  confirmPanelShow=false"  @updateflag="updateflag()"/>
      <!--支明细弹窗-->
      <el-dialog :visible.sync="record" width="560px" center id="record" class="text-dialog" top="36vh">
          <Record :OrderDetail="orderDetail" :type="storeInfo.type" ></Record>
      </el-dialog>
      <!--打款回单弹窗-->
      <el-dialog title="打款回单" :visible.sync="dialogFormVisible" width="1400px" class="paymentist"  z-index="9">
          <Receipt :receiptInfo="orderDetail"></Receipt>
      </el-dialog>
      <!--打印订单-->
      <Print :OrderDetail="orderDetail" v-if="printkle" @printPage='printkle=false'></Print>
      <!--支付弹窗-->
      <el-dialog :visible.sync="paymentOpen" width="650px" center id="paymentOpen" class="custom-dialog" top="36vh">
        <Payment  :OrderDetail="orderDetail"   @open="paymentState=true" />
      </el-dialog>
      <!--支成功弹窗-->
      <el-dialog :visible.sync="paySuccess" width="360px" center id="paySuccess" class="text-dialog" top="36vh">
        <div class="text-center">
          <img src="/images/logo/zfcg.png" alt="" class="mb-2">
          <p class="text-suc">支付成功</p>
          <div class="text-center-bottom" @click="paySuccess=false">返回详情</div>
        </div>
      </el-dialog>
      <!--修改订单金额弹窗-->
      <OrderModifyDeposit :onShow="modifyDepositShow" :orderDetail="orderDetail" @onShow="modifyDepositShow=false" @getorderDetail="getorderDetail();modifyDepositShow=false" />
      <!--确认二维码-->
      <el-dialog  :visible.sync="payQrcodeShow" width="360px"  :show-close="false" center  :z-index="15" top="32vh" >
          <div class="onDehalf-title">
              <div>{{orderDetail.title}}</div>
              <img :src="payQrcodeImg" width="200px" height="200px" class="base64Img">
              <p class="hotel-title">可扫码查看或分享确认</p>
              <el-button  @click="payQrcodeShow=false" class="bottom mt-3" size="small">返回</el-button>
          </div>
      </el-dialog>
      <!--上传发票-->
      <OrderuploadInvoice :invoiceType="invoiceType" :onShow="uploadInvoiceShow" :editMode="editMode||isAdmin" :orderDetail="orderDetail" @isClick="isClick=false"  :existImgs="existImgs" @onShow="uploadInvoiceShow=!uploadInvoiceShow" @getorderDetail="getorderDetail();" />
      <!--右侧浮动-二维码加询价清单-->
      <!-- <right-tab-bar></right-tab-bar> -->
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions,mapMutations } from 'vuex'
import OrderState from './Components/OrderState' //订单状态
import OrderTeam from './Components/OrderTeam' //订单团队信息
import OrderHousing from './Components/OrderHousing' //用房信息
import OrderQuotation from './Components/OrderQuotation' //酒店报价列表
import OrderHotelQuotation from './Components/OrderHotelQuotation' //酒店报价列表
import OrderHotelFill from './Components/OrderHotelFill' //酒店报价列表
import OrderHoteRefuse from './Components/OrderHoteRefuse' //酒店报价列表
import OrderCheckList from './Components/OrderCheckList' //核房人、支付人、入住名单
import Orderbutton from './Components/Orderbutton/index' //订单按钮组件
import OrderCollectionOnDehalf from './Components/OrderCollectionOnDehalf' //代订收款弹窗 
import OrderFlagMarker from './Components/OrderFlagMarker' //标注信息旗
import OrderConfirmPanel from './Components/OrderConfirmPanel' //查看修改弹窗
import Record from '@/views/payment/Record.vue';                              //支付明细
import Receipt from '@/views/Admin/FinancialManage/FinancialStats/Receipt.vue' //打款回单
import Print from './Components/Print' //打印订单
import Payment from '../../../payment/index.vue'; //支付弹窗
import OrderModifyDeposit from './Components/OrderModifyDeposit.vue'; //修改订单金额弹窗
import OrderuploadInvoice from './Components/OrderuploadInvoice.vue'; //上传发票弹窗
import RightTabBar from '@/components/PublicComp/RightTabBar.vue';    //微信分享
export default {
  name: 'OrderIndex',
  components: {
    OrderState,
    OrderTeam,
    OrderHousing,
    OrderQuotation,
    OrderHotelQuotation,
    OrderHotelFill,
    OrderHoteRefuse,
    OrderCheckList,
    Orderbutton,
    OrderCollectionOnDehalf,
    OrderFlagMarker,
    OrderConfirmPanel,
    Record,
    Receipt,
    Print,
    Payment,
    OrderModifyDeposit,
    OrderuploadInvoice,
    RightTabBar,
  },
  props: {
    orderId: {              //订单ID
      type: String,
      required: true
    }
  },
  data() {
    return {
      orderDetail: {
        room_need_arr:[],
        meeting_need_arr:[],
        pay_arr:[],
        verify_arr:[],
      },                 //订单详情
      quotationList: {},                               //询价状态·酒店报价列表
      clockCount:'',                  //询价倒计时
      collectionShow:false,           //代订收款弹窗
      /*************************酒店信息**************************/ 
      my_offer: {},                   //酒店已报价列表
      match_hotel_list:[],            //酒店未报价列表
      quotationShow: false,           //酒店报价弹窗
      refuseShow:false ,              //接不了弹窗
      hotel_id: '',                  //报价酒店ID
      /*订单取消弹窗*/
      showConfirmPanel: false,       //订单取消弹窗
      showShopCar:false,             //订单取消验证码弹窗
      arrow_down: '',                //订单原因
      confirmPanelShow:false,                      //查看修改弹窗
      record:false,                                //支明细弹窗
      dialogFormVisible:false,                     //打款回单弹窗
      printkle:false,                              //打印订单弹窗
      paymentOpen:false,                           //支付弹窗
      paySuccess:false,                            //支付成功弹窗
      modifyDepositShow:false,                     //修改订单金额弹窗
      payQrcodeImg:'',
      payQrcodeShow:false,
      loading:false,
      paymentDetail:{},
      cancelPrompt:false,                          //取消原因提示
      showCancelPanel:false,                       //查看取消状态弹窗    
      uploadInvoiceShow:false,                     //上传发票弹窗
      editMode:false,                              //是否编辑发票
      existImgs:'',                                //已存在发票
      isClick:false,                                //禁止连续点击
      invoiceType:'',                               //发票点击的身份值
    }
  },
  computed: {
    ...mapGetters(['storeInfo','isGroup','isAdmin']),
    ...mapState(['newMessageInform','userLoginMessage']),
     //酒店报价时选择订单进入的报价的酒店ID
     match_store_id () { return this.$route.query.match_store_id},
    //修改成功返回订单详情-给出提示框
     modify () { return this.$route.query.modify},
       //修改成功返回订单详情-给出提示框
     flag () { return this.$route.query.flag||''},
  },
  watch: {
    newMessageInform(newVal) {
        // 消息类型——酒店销售监听的[39，旅行社撤销修改订单通知，46，旅行社撤销修改订单通知]
        // 消息类型——采购商监听的[7，订单有新报价,40,酒店同意修改,5酒店审核通过]
        const types = this.storeInfo.type==3?[30,44,43,39,46,45]:[40,7,42,47,5,43,44,30]; 
        //收到通知刷新当前页面
        if (newVal && this.$GFUN.isInArray(types,newVal.type) && newVal.oid==this.orderId){
          //更新我的报价列表
          if(newVal.type==7){
            this.$refs.orderQuotation.loadList();
          }
          this.getorderDetail();
          //如果当前正常查看,关闭修改弹窗
          this.confirmPanelShow=false;
        }
    },
  },
  created() {},
  mounted() {
    this.getorderDetail();
    if(this.modify){
      let modify=this.modify;
      //修改后提示信息
      let hint=modify==1?'订单修改成功':'等待确认期间不允许修改';
      this._alert(modify==3?'设置代订收款完成':hint,()=>{
          // 复制原有query，单独修改modify
          const newQuery = {
            orderId:this.orderId,
          }
          this.$router.replace({
            path: this.$route.path,
            query: newQuery
          })
      },null,'error');
    }
  },
  methods: {
    ...mapActions(['getUserIndexData','getUserIndexData','POST_EndCancelOrderHotel','POST_RevokeCancelOrderHotel','POST_OrderHotelDetail','cancellationOfOrder','adminPaymentInfor','adminVerifyOrder','POST_GetOrderDetailQRCode','POST_RefuseOrderHotelConfirm','POST_StartCancelOrderHotel']),
        //开始上传发票
    uploadInvoice(e){
      if(!this.isClick){
        this.invoiceType=e.type;
        this.editMode=e.editMode;
        if(this.existImgs===e.receipt||e.receipt==''){
          this.uploadInvoiceShow=true;
          return;
        }
        this.isClick=true;
        this.existImgs=e.receipt;
      } 
    },
    //获取订单详情
    getorderDetail(){
      this.POST_OrderHotelDetail({data:{oid:this.orderId,flag:this.flag}}).then(res => {
        //订单详情
        if(this.flag){
          res.info.room_need_arr.list=[
            {
              date:this.$route.query.date,
              offer_info:JSON.parse(this.$route.query.offer_info),
            }
          ];
          res.info.room_need_arr.num=0;
          this.orderDetail.offer_name= res.select_hotel.offer_name||'';
           this.orderDetail.offer_mobile= res.select_hotel.offer_mobile||'';
        }
        this.orderDetail={
          ...this.orderDetail,
          ...res.info,
          need_mode:this.flag?[]:res.info.room_need_arr.mode,
          room_need_arr:res.info.room_need_arr,
          meeting_need_arr:this.flag?[]:res.info.meeting_need_arr,
        };
        //成交订单状态·前台电话-提供早餐
        if(res.info.deal_time>0){
          this.orderDetail.hotel_tel=res.select_hotel.hotel_tel;
          this.orderDetail.hotel_breakfast_type=res.select_hotel.breakfast_type;
        }
        //************供应商订单************-->
        //报价状态
        if((this.storeInfo.type==2||this.storeInfo.type==99)&&res.info.status==4){
            this.my_offer=res.my_offer;
            this.quotationList={
              ...res.offer,
              list:res.offer.list.map(item=>{
                return {
                  ...item,
                };
              }) 
            };
            this.setClockCount();
        }
        //酒店销售且在报价的状态
        if(this.storeInfo.type==3&&res.info.status==4){
          this.initHotelData(res);
        }
      })
    },
    //更新标识数量
    updateflag(){
      this.getUserIndexData();
    },
    //酒店销售初始化数据
    initHotelData(res){
        //默认未报价添加报价值
        //初始化默认都有初始房型跟报价列表ID门店名称一致
        res.match_hotel_list.forEach(item=>{
            item.oid=this.orderDetail.oid;                      //订单ID
            item.store_id=item.match_store_id;                  //酒店ID
            item.offer_store_id=item.match_store_id;
            item.room_offer_arr=res.info.room_need_arr;
            item.meeting_offer_arr=res.info.meeting_need_arr;
            item.whetherQuote=false;                          //是否报价标识-未报价
            item.offer_type=res.info.offer_type||'';                               //报价状态-未报价
        });
        res.my_offer.list.forEach(item=>{
            item.whetherQuote=true;                           //是否报价标识-已报价
        });
        //报价列表跟未报价列表相同ID合并
        let roomStyle=this.$_Array.mergeArrById(res.match_hotel_list,res.my_offer.list,'offer_store_id');
        
        //询价状态·已酒店报价列表
        this.quotationList={
          ...res.my_offer,
          list:res.my_offer.list.map(item=>{
            return {
              ...item,
              room_offer_arr:this.getList(item.room_offer_arr),
              meeting_offer_arr:this.getList(item.meeting_offer_arr),
            };
          }) 
        };
        console.log(roomStyle);
        //询价状态·未酒店未报价列表
        this.match_hotel_list=roomStyle;
    },
    //封装取值函数
    getList(obj) {
      if (!obj || !obj.list) return [];
      return obj.list
    },
    //开启酒店报价弹窗
    onquotationShow(e){
      this.quotationShow=true;
      this.$refs.OrderHotelFill.betterOfferHotel(e.store_id)
    },
    //开启酒店接不了弹窗
    onrefuseShow(e){
      this.refuseShow=true;
      this.$refs.OrderHoteRefuse.betterOfferHotel(e.store_id)
    },
    //开启修改弹窗
    onViewChanges(){
      this.confirmPanelShow=true;
      this.$refs.confirmPanel.POST_OrderHotelDetail({data:{oid:this.orderDetail.oid}});
    },
    /*计算订单有效期倒计时*/
    setClockCount () {
        this._timer = setInterval(() => {
          let timeDiff = this.$GFUN.getTimeDiff(this.orderDetail.date_in*1)
          this.clockCount = '剩' + timeDiff + '自动取消'
          if (timeDiff === '订单过期已失效') {
            this.clockCount = '订单超时，已自动取消';
            clearInterval(this._timer);
          }
        }, 1000)
    },
    /*弹出短信验证框*/
    number(){
          if(this.arrow_down==''){
                this.cancelPrompt=true;
          }else{
            this.showConfirmPanel=!this.showConfirmPanel;
            this.cancel_type=this.arrow_down;
            this.arrow_down=''
            //已成交取消订单
            if(this.orderDetail.deal_time>0){
              this.POST_StartCancelOrderHotel({
                data:{
                  oid:this.orderDetail.oid,
                  cancel_remark:this.cancel_type,
                },
                successFun: () => {
                  this._alert('发起成功，等待对方确认');
                  this.updateflag();
                  this.getorderDetail();
                }
              })
            //未成交取消订单
            }else{
                this.submitOrder();
            }
          }
        
    },
    //查看回执单
    handleCommand(Itemize) {
      this.adminPaymentInfor({
          data:{pay_id:Itemize.pay_id_hotel},
          successFun: (res) => {
              this.receiptInfo=res;
              this.dialogFormVisible=true;
          }
      })
    },
    /*取消订单*/
    submitOrder() {
      let POST=this.cancellationOfOrder;
      let Remarks=this.orderDetail.deal_time>0?'取消订单成功':this.orderDetail.status==5?'取消确认单成功':'订单已结束询价';
      //如果不是发布则默认酒店拒绝订单
      if(this.orderDetail.status==5&&this.orderDetail.send_type!=this.storeInfo.type){
        POST=this.POST_RefuseOrderHotelConfirm;
        Remarks='酒店拒绝订单成功';
      }
        POST({
            data:{
              oid:this.orderDetail.oid,
              cancel_remark:this.cancel_type,
              ask_type:this.orderDetail.ask_type,
            },
            successFun: () => {
                this.getorderDetail();
                this.showShopCar = false;
                this._alert(Remarks);
                this.updateflag();
            }
        });
    },
    /*撤销取消订单*/
    cancelCancel(){
      this._confirm('确定撤销取消订单么',() => {
        this.POST_RevokeCancelOrderHotel({
          data:{
            oid:this.orderDetail.oid,
          },
          successFun: () => {
            this.getUserIndexData();
            this.getorderDetail();
            this.showCancelPanel = false;
            this._alert('撤销取消订单成功');
          }
        })
      })
    },
    /*确认取消订单*/
    confirmCancel(e){
      this._confirm(e==0?'确定拒绝取消订单么':'确定同意取消订单么',() => {
        this.POST_EndCancelOrderHotel({
          data:{
            oid:this.orderDetail.oid,
            action:e,
          },
          successFun: () => {
            this.getUserIndexData();
            this.getorderDetail();
            this.showCancelPanel = false;
            this._alert('操作成功');
          }
        })
      })
    },
    /*管理员审核订单*/
    verifyOrder(flag) {  
      this._confirm('确定操作么',() => { 
        this.adminVerifyOrder({data:{flag:flag,oid:this.orderDetail.oid},successFun: (res) => {
            this.getorderDetail();
        }}) 
      })
    },
    //获取确认二维码
    getQRcode(){
        let _this=this;
        //已获取过不重新调用
        if(this.payQrcodeImg){
            this.payQrcodeShow=true;
            return;
        }
        //获取确认二维码
        this.loading=true;
        this.POST_GetOrderDetailQRCode({
            data:{
                oid: this.orderDetail.oid
            },
            successFun: (res) => {
                _this.payQrcodeImg='data:image/jpeg;base64,'+res.qr_code;
                _this.payQrcodeShow=true;
                _this.loading=false;
            }
        })
    },
    //取消订单建议文字
    querySearch(queryString, cb) {
      console.log(this.storeInfo);
      let results=this.storeInfo.type==3?this.$GVAR.hotelReason:this.$GVAR.travelReason
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    //点击建议框
    handleSelect(item) {
        this.arrow_down=item.value;
    },
  }
};
</script>

<style lang="scss" scoped>
*{
  text-align: left;
}
.OrderIndex{
  width: 100%;
  min-width: 1400px;
  margin: 0 auto;
  // position: relative; 
}
.order-detail{
  display: flex;
}
.order-detail-title{
  font-weight: bold;
  font-size: 24px;
  color: #333;
}
.order-detail-content{
  margin-left: 20px;
  margin-top: 12px;
}
.housing{
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
}
.order-detail-end{
  margin-left: auto;
  display: flex;
  line-height: 35px;
}
.check{
  display: flex;
  justify-content: space-between;
}
.selects{
  margin: 0 auto;
  width: 100%;
}
.cancel{
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
}
  .onDehalf-title{
      font-size: 18px;
      font-weight: bold;
      color: #333;
      text-align: center;
      position: relative;
      div{
        text-align: center;
      }
  }
  .base64Img{
      margin-top: 20px;
  }
  .hotel-title{
      color: #999;
      font-size: 12px;
      font-weight: normal;
      margin-top: 8px;
      text-align: center;
  }
  .cancelPrompt{
    color: red;
    font-size: 12px;
    margin-top: 10px;
  }
  .cancel-prompt{
    font-size: 12px;
    margin-top: 16px;
    background-color: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
  }
  .cancel-title{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
</style>
<style>
  .OrderIndex .el-dialog__header{
    padding: 0;
    margin-bottom: 0;
  }
</style>